import { HttpClient, HttpParams } from '@angular/common/http';
import { provideTransloco, Translation, TranslocoLoader } from '@jsverse/transloco';
import { Inject, Injectable, isDevMode } from '@angular/core';
import { HX_APP_VERSION, HX_COMPONENT_NAME, isoDate } from './interface';

@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(
    private http: HttpClient,
    @Inject(HX_COMPONENT_NAME) private componentName: string,
    @Inject(HX_APP_VERSION) private appVersion: string,
    ) {
  }

  getTranslation(lang: string) {
    return this.http.get<Translation>(`assets/i18n/${lang}.json`, {params: new HttpParams().set('app_version', this.appVersion ?? isoDate(Date.now()))});
  }
}

export const provideTranslocoFn = () => provideTransloco({
  config: {
    availableLangs: ['en', 'ru', 'kk'],
    defaultLang: ['us', 'pro'].includes(location.hostname.split('.')[location.hostname.split('.').length - 1]) ? 'en': 'ru',
    // Remove this option if your application
    // doesn't support changing language in runtime.
    fallbackLang: ['us', 'pro'].includes(location.hostname.split('.')[location.hostname.split('.').length - 1]) ? 'en': 'ru',
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
  },
  loader: TranslocoHttpLoader
});
